import React from 'react';
import { StyleSheet } from 'react-native';

import { LoadingPlaceholder, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────

export const NotificationPreferencesSkeleton = () => {
  return (
    <LoadingPlaceholder style={styles.contentSpacing} rowHeight={ROW_HEIGHT} palette="quinoa" />
  );
};

// ─── Constants ───────────────────────────────────────────────────────

const ROW_HEIGHT = 200;

// ─── Styles ──────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  contentSpacing: {
    marginBottom: theme.spacing['5'],
  },
});
